import React, { useState } from 'react';
import { Autocomplete, InputBase } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { spacing, radius, height, colors, FontFamily, typographyScale, TypographyVariant } from 'common/theme';
import { FormFieldWrapper } from 'components/common/FormFieldWrapper';

const getInputBaseStyles = (theme, disabled, error, isFocused) => ({
  width: '100%',
  height: height.input,
  fontFamily: FontFamily.regular,
  fontSize: typographyScale[TypographyVariant.BodyLarge].fontSize,
  padding: `${spacing.md}px`,
  borderRadius: `${radius.md}px`,
  border: `1px solid ${
    error
      ? theme.palette.error.main
      : isFocused
      ? colors.palette.blue550
      : colors.palette.blueAlpha200
  }`,
  backgroundColor: colors.palette.white,
  transition: 'border-color 0.2s ease',
  '&:hover': {
    borderColor: !disabled && colors.palette.blue550,
  },
  '&.Mui-disabled': {
    backgroundColor: 'transparent',
  },
});

export const AutocompleteFieldHot = ({
  testID,
  label,
  options,
  value,
  onChange,
  placeholder,
  noOptionsText = 'לא נמצאו תוצאות',
  getOptionLabel,
  isOptionEqualToValue,
  disabled = false,
  error = false,
  helperText,
  sx,
}) => {
  const theme = useTheme();
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <FormFieldWrapper label={label} testID={testID} disabled={disabled} error={error} helperText={helperText} sx={sx}>
      <Autocomplete
        options={options}
        value={value || null}
        onChange={(event, newValue) => {
          onChange(event, newValue);
        }}
        disabled={disabled}
        clearOnBlur={false}
        disableClearable={false}
        getOptionLabel={getOptionLabel || ((option) => option?.label || '')}
        isOptionEqualToValue={isOptionEqualToValue || ((option, val) => option?.id === val?.id)}
        renderInput={(params) => {
          const inputProps = params.inputProps || {};
          return (
            <InputBase
              {...params.InputProps}
              inputProps={{
                ...inputProps,
                ...(testID ? {
                  testid: `${testID}-input`,
                } : {}),
                onFocus: (e) => {
                  handleFocus();
                  if (inputProps.onFocus) inputProps.onFocus(e);
                },
                onBlur: (e) => {
                  handleBlur();
                  if (inputProps.onBlur) inputProps.onBlur(e);
                },
              }}
              placeholder={placeholder}
              disabled={disabled}
              sx={{
                ...getInputBaseStyles(theme, disabled, error, isFocused),
                ...(disabled && {
                  backgroundColor: 'transparent',
                }),
              }}
            />
          );
        }}
        noOptionsText={noOptionsText}
        sx={{ width: '100%' }}
      />
    </FormFieldWrapper>
  );
};

export default AutocompleteFieldHot;

